import React from 'react';
import { Create, List, SaveButton, Datagrid, DateField, TextField, NumberField, Edit, required,
  Toolbar, TextInput, Filter, ArrayInput, SimpleFormIterator, BooleanInput, TabbedForm, FormTab } from 'react-admin';

const GamAccountTitle = ({ record }) => {
    return <span>Account {record ? `"${record.name}"` : ''}</span>;
};
/**
 * Adds filtering functionality
 * @param {} props 
 */
const GamAccountFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn resettable />
    </Filter>
);

export const GamAccountList = (props) => (
    <List {...props} filters={<GamAccountFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="code" label="ID" />
            <TextField source="name" label="Name" />
        </Datagrid>
    </List>
);

class GamForm extends React.Component {
  render () {
    return (
      <TabbedForm toolbar={<CustomToolbar />} {...this.props} >
        <FormTab label="Account Settings">
          <NumberField source="code" label="GamAccount ID" validate={required()} />
          <TextInput source="name" label="Name" validate={required()} />
          <TextInput source="network_code" label="GAM Network Code" validate={required()} />
          <TextInput source="advertiser_id" label="Nobid Advertiser ID" validate={required()} helperText="GAM Company ID"/>
          <TextInput source="trafficker_id" label="Trafficker ID" helperText="GAM Access User ID"/>
          <TextInput source="root_adunit" label="Root Ad Unit" validate={required()} />
          <TextInput source="nobid_parent_adunit" label="Nobid Parent Ad Unit" validate={required()} />
        </FormTab>
        <FormTab label="Reporting Settings">
          <BooleanInput source="adx_tag_report" />
          <TextInput source="oauth_path" /* validate={required()} */ />
          <TextInput source="custom_targeting_key_id" /* validate={required()} */ />
          <TextInput source="tag_bidder_id" /* validate={required()} */ />
          <ArrayInput source="order_ids" label='Order IDs' style={{ width: '30%' }}>
            <SimpleFormIterator>
              <TextInput label="Order ID"/>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    )
  }
}

export const GamAccountEdit = (props) => (
  <Edit title={<GamAccountTitle />} {...props}>
    <GamForm parent={this}/>
  </Edit>
)

export const GamAccountCreate = (props) => (
  <Create title="Create GamAccount" {...props}>
    <GamForm parent={this}/>
  </Create>
)

const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <br />
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
    </Toolbar>
);
